import React from 'react';

/**
 * ErrorBoundary específico para AnexosManager.
 * Se o AnexosManager crashar por qualquer motivo (dados mal-formatados,
 * bug em algum anexo específico, etc.), a tela ao redor continua funcional.
 * O usuário vê uma mensagem amigável e pode continuar editando o restante.
 */
class AnexosErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log para Sentry/console mas não quebra a app
    console.error('[AnexosErrorBoundary]', error, errorInfo);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="border border-amber-300 bg-amber-50 rounded-lg p-4 text-sm text-amber-900"
          data-testid="anexos-error-boundary"
        >
          <div className="font-medium mb-1">
            ⚠️ Não foi possível carregar os anexos deste registro
          </div>
          <div className="text-xs text-amber-700 mb-2">
            Os dados de anexos podem estar corrompidos. O restante do formulário continua disponível.
          </div>
          <button
            type="button"
            onClick={this.reset}
            className="text-xs underline hover:text-amber-600"
          >
            Tentar novamente
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AnexosErrorBoundary;
